import axios from 'axios';
import { type } from 'jquery';

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
const AuthAPI = axios.create({ baseURL: `${BACKEND_BASE_URL}/api/v1/user` });


// Request interceptor to add authorization and accept headers
AuthAPI.interceptors.request.use(
  (req) => {
    const userToken = localStorage.getItem('token');
    if (userToken) {
        req.headers.Authorization = `Bearer ${userToken}`;
        req.headers.Accept = 'application/json';
    }
    return req;
  },
  (error) => {
    // console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle responses and errors
AuthAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with a status other than 2xx
      if (error.response.status === 401) {
        // console.error('Unauthorized access - possibly due to expired token');
      } else {
        const responseErrors = error?.response?.data?.errors;
        const fallbackMessage = error?.response?.data?.message || "An error occurred";
        if (responseErrors) {
          // console.error('Response errors:', responseErrors);
        } else {
          // console.error('Response error:', fallbackMessage);
        }
      }
    } else if (error.request) {
      // Request was made but no response received
      // console.error('No response received:', error.request);
    } else {
      // Something else caused the error
      // console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);



export const getAuthenticatedUser = () => AuthAPI.get('/profile');

export const registerUser = (userData) => AuthAPI.post('/register', userData);
export const resendEmailOtp = (email) => AuthAPI.post('/email-verification/send-otp', { email: email, type: 'verify-email' });
export const verifyEmailOtp = (email, otpCode) => AuthAPI.post('/email-verification/verify-otp', { type: 'verify-email', otp: otpCode});
export const googleAuth = (credentials) => AuthAPI.post('/oauth/callback', credentials);

export const verifyEmail = (email) => AuthAPI.post('/check-email', { email });

export const loginUser = (credentials) => AuthAPI.post('/login', credentials);
export const resendLoginOtp = (email) => AuthAPI.post('/login/resend-2fa', { email });
export const verifyLoginOtp = (credentials) => AuthAPI.post('/login/verify-2fa', credentials);

export const passwordReset = (email) => AuthAPI.post('/reset-password/send-otp', { email, type: 'reset-password' });
export const resendPasswordOtp = (email) => AuthAPI.post('/reset-password/send-otp', { email, type: 'reset-password' });
export const verifyRecoveryOtp = (email, otpCode) => AuthAPI.post('/verify-otp', { email, otp: otpCode});
export const changePassword = (passwordData) => AuthAPI.post('/reset-password/change-password', passwordData);
export const changeAccountPassword = (passwordData) => AuthAPI.put('/update-password', passwordData);

export const logoutUser = () => AuthAPI.post('/logout');

export default AuthAPI;